import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  ViewChildren,
  ElementRef,
  QueryList,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { BaseComponent } from '../../../shared/utils/base.component';
import { AddressComponent } from '../../../shared/components/address/address.component';
import { SectionsService } from '../../../services/sections.service';
import { Router } from '@angular/router';
import { ReferralDataService } from '../../../services/referral-data.service';
import { Subscription } from 'rxjs';
import { ContactDetailsData } from '../../../interfaces/referralSections.interface';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { performValidation } from '../../../shared/utils/validation.util';
import { CommonModule } from '@angular/common';
import {
  RADIO_YES_NO_OPTIONS,
  STATIC_DATA,
} from '../../../shared/constants/static-data.constants';
import { UserService } from '../../../services/user.service';
import { PPLRadioFocusDirective } from '../../../shared/directives/ppl-radio-focus.directive';
import { AutoFocusHeaderDirective } from '../../../shared/directives/auto-focus-header.directive';

@Component({
  selector: 'ppl-contact-details',
  standalone: true,
  imports: [
    NzFormModule,
    FormsModule,
    ReactiveFormsModule,
    NzGridModule,
    NzCardModule,
    NzSwitchModule,
    NzToolTipModule,
    AddressComponent,
    NzDividerModule,
    NzRadioModule,
    NzCheckboxModule,
    CommonModule,
    PPLRadioFocusDirective,
    AutoFocusHeaderDirective
  ],
  templateUrl: './contact-details.component.html',
  styleUrl: './contact-details.component.css',
})
export class ContactDetailsComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  private navigationSubscription: Subscription | undefined;
  @Input() mode = 'edit';
  @Input() source?: string = '';
  filledInfo: ContactDetailsData = {};
  contactForm!: FormGroup;
  communicationType: any[] = [];
  formHasBeenFilled = false;
  radioOptions = RADIO_YES_NO_OPTIONS;
  showPSD = true;
  isMailing = true;
  flow: string | null = '';
  permanentValidationErrors: any;
  mailingValidationErrors: any;
  formReadonly = false;
  isMinor = false;
  private readonly participantFlows = ['participantEnrollment'];
  private readonly parentAttestationFields = ['email', 'mobile', 'altPhone'];
  @ViewChildren('radioBtn', { read: ElementRef }) radioButtons!: QueryList<ElementRef>;
  constructor(
    private fb: FormBuilder,
    private sectionService: SectionsService,
    private router: Router,
    private referralDataService: ReferralDataService,
    private userService: UserService
  ) {
    super();
  }

  ngOnInit(): void {
    this.contactForm = this.fb.group({
      preferredMethod: [''],
      email: [''],
      altPhone: [''],
      mobile: [''],
      residentGt18: [''],
      yearsInState: [''],
      familyAccount: [false],
      permanentAddress: this.fb.group({
        street1: [''],
        street2: [''],
        countyOrRegion: [''],
        state: [''],
        zipCode: [''],
        city: [''],
        psd_code: [''],
        mailing: [true],
      }),
      mailingAddress: this.fb.group({
        countyOrRegion: [''],
        street2: [''],
        city: [''],
        state: [''],
        zipCode: [''],
        street1: [''],
        psd_code: [''],
      }),
    });

    const program = this.userService.getSelectedProgram();
    this.flow = this.sectionService.getFlow()!;
    if (!this.participantFlows.includes(this.flow ?? '')) {
      this.contactForm.removeControl('familyAccount');
    }
    const associationFlows = [
      'employer',
      'authRepresentative',
      'provider',
      'vendor',
      'contractor',
      'legalGuardian',
      'poa',
    ];
    this.formReadonly = this.referralDataService.getAssociationsEditable();

    if (this.formReadonly) {
      this.contactForm.disable();
    } else {
      this.contactForm.enable();
    }

    let steps: any;
    if (this.flow === 'providerEnrollment') {
      steps = this.sectionService.getProviderSectionData(
        program?.program_code,
        STATIC_DATA.CONTACT_DETAILS
      );
      this.secData = steps;
    } else {
      steps = this.sectionService.getSectionData(
        program?.program_code,
        this.source
      );
      this.secData = steps[STATIC_DATA.CONTACT_DETAILS];
    }

    this.showPSD = program?.program_code !== 'NY';
    const validFlows = [
      'referral',
      'providers',
      'participants',
      'add_independentContractor',
      'add_vendor',
      'add_individualProvider',
    ];
    this.isMailing = this.flow !== null && validFlows.includes(this.flow);

    this.navigationSubscription = this.contactForm.valueChanges.subscribe(
      () => {
        const hasValue = this.hasAnyValueInForm(this.contactForm);
        this.contactForm.markAsDirty();
        console.log(hasValue);
        this.formHasBeenFilled = hasValue;

        if (!associationFlows.includes(this.flow ?? '')) {
          this.referralDataService.setReferralFormData(
            'isContactFormUpdated',
            this.formHasBeenFilled
          );
        } else {
          this.referralDataService.setAssociationFormData(
            'isContactFormUpdated',
            this.formHasBeenFilled
          );
        }
        // this.referralDataService.setReferralFormData("isContactFormUpdated", this.formHasBeenFilled);

        console.log(this.contactForm.value);
        if (!associationFlows.includes(this.flow ?? '')) {
          if (this.contactForm.get('permanentAddress')?.value.mailing) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { mailing, ...mailingAddressValue } =
              this.contactForm.get('permanentAddress')?.value;
            this.contactForm.value.mailingAddress = mailingAddressValue;
            /* console.log(mailingAddressValue, 'mailing address');
          console.log(this.contactForm.value.mailingAddress); */
          }
          this.referralDataService.setReferralFormData(
            'contactDetailsData',
            this.contactForm.value
          );
        } else {
          this.referralDataService.setAssociationFormData(
            'contactDetailsData',
            this.contactForm.value
          );
        }
        this.referralDataService.setChanged(
          !hasValue ? false : this.contactForm.dirty
        );
        if (!associationFlows.includes(this.flow ?? '')) {
          this.referralDataService.setReferralFormData(
            'isContactFormDirty',
            !hasValue ? false : this.contactForm.dirty
          );
        } else {
          this.referralDataService.setAssociationFormData(
            'isContactFormDirty',
            !hasValue ? false : this.contactForm.dirty
          );
        }
      }
    );

    this.communicationType = this.getLookup('Communication_Type');
    if (associationFlows.includes(this.flow ?? '')) {
      const filledData =
        this.referralDataService.getAssociationDetails('contactDetailsData')!;
      if (filledData) {
        this.contactForm.patchValue(filledData);
      }
    }
    if (
      ((this.flow == 'referral' &&
        this.userService.getLeadEntry() == 'referral') ||
        this.flow === 'participantEnrollment' ||
        this.flow === 'providerEnrollment') &&
      !this.referralDataService.getReferralFormData().contactDetailsData
    ) {
      const filledData = this.referralDataService.getReferralDetails(
        'contactDetailsData',
        this.flow
      )!;
      if (filledData) {
        this.contactForm.patchValue(filledData);
      }
    }

    if (!associationFlows.includes(this.flow ?? '')) {
      if (this.referralDataService.getReferralFormData().contactDetailsData) {
        this.filledInfo =
          this.referralDataService.getReferralFormData().contactDetailsData;
        this.contactForm.patchValue(this.filledInfo);
      }
    } else {
      if (
        this.referralDataService.getAssociationFormData().contactDetailsData
      ) {
        this.filledInfo =
          this.referralDataService.getAssociationFormData().contactDetailsData;
        this.contactForm.patchValue(this.filledInfo);
      }
    }
    this.initMinorAttestation();

    if (associationFlows.includes(this.flow ?? '')) {
      this.referralDataService.associationSaveClicked.subscribe(() => {
        let mailingAddressErrors: any = {};
        const permanentAddressErrors = performValidation(
          this.contactForm.get('permanentAddress')?.value,
          this.secData,
          'Next', undefined, undefined, this.sectionService.getFlow(), this.sectionService.getEnrollmentType()
        );
        if (permanentAddressErrors) {
          delete permanentAddressErrors?.email;
          delete permanentAddressErrors?.mobile;
          delete permanentAddressErrors?.altPhone;
          this.permanentValidationErrors = permanentAddressErrors;
        }
        if (!this.contactForm.get('permanentAddress')?.value.mailing) {
          mailingAddressErrors = performValidation(
            this.contactForm.get('mailingAddress')?.value,
            this.secData,
            'Next', undefined, undefined, this.sectionService.getFlow(), this.sectionService.getEnrollmentType()
          );
          if (mailingAddressErrors) {
            delete mailingAddressErrors?.email;
            delete mailingAddressErrors?.mobile;
            delete mailingAddressErrors?.altPhone;
            this.mailingValidationErrors = mailingAddressErrors;
          }
        }

        const formErrors = performValidation(
          this.contactForm.value,
          this.secData,
          'Next', undefined, undefined, this.sectionService.getFlow(), this.sectionService.getEnrollmentType()
        );
        delete formErrors.city;
        delete formErrors.countyOrRegion;
        delete formErrors.state;
        delete formErrors.street1;
        delete formErrors.zipCode;
        this.validationErrors = {
          ...permanentAddressErrors,
          ...mailingAddressErrors,
          ...formErrors,
        };
        this.referralDataService.setError(this.validationErrors);
        this.referralDataService.setAssociationFormData(
          'isContactFormValid',
          Object.keys(this.validationErrors).length == 0
        );
      });
    }

    this.referralDataService.nextClicked.subscribe((val: any) => {
      if (val === STATIC_DATA.CONTACT_DETAILS) {
        let mailingAddressErrors: any = {};
        const permanentAddressErrors = performValidation(
          this.contactForm.get('permanentAddress')?.value,
          this.secData,
          'Next', undefined, undefined, this.sectionService.getFlow(), this.sectionService.getEnrollmentType()
        );
        if (permanentAddressErrors) {
          delete permanentAddressErrors?.email;
          delete permanentAddressErrors?.mobile;
          delete permanentAddressErrors?.altPhone;
          this.permanentValidationErrors = permanentAddressErrors;
        }
        if (!this.contactForm.get('permanentAddress')?.value.mailing) {
          mailingAddressErrors = performValidation(
            this.contactForm.get('mailingAddress')?.value,
            this.secData,
            'Next', undefined, undefined, this.sectionService.getFlow(), this.sectionService.getEnrollmentType()
          );
          if (mailingAddressErrors) {
            delete mailingAddressErrors?.email;
            delete mailingAddressErrors?.mobile;
            delete mailingAddressErrors?.altPhone;
            this.mailingValidationErrors = mailingAddressErrors;
          }
        }

        const formErrors = performValidation(
          this.contactForm.value,
          this.secData,
          'Next', undefined, undefined, this.sectionService.getFlow(), this.sectionService.getEnrollmentType()
        );
        delete formErrors.city;
        delete formErrors.countyOrRegion;
        delete formErrors.state;
        delete formErrors.street1;
        delete formErrors.zipCode;
        if (this.familyAccount) {
          this.parentAttestationFields.forEach((field) => delete formErrors[field]);
        }
        this.validationErrors = {
          ...permanentAddressErrors,
          ...mailingAddressErrors,
          ...formErrors,
        };
        this.referralDataService.setError(this.validationErrors);
      }
    });
  }

  private initMinorAttestation(): void {
    if (!this.participantFlows.includes(this.flow ?? '')) {
      return;
    }
    const infoData =
      this.referralDataService.getReferralFormData().infoData ||
      this.referralDataService.getReferralDetails('infoData', this.flow ?? undefined);
    this.isMinor = this.isUnder18(infoData?.dob);
    if (!this.isMinor) {
      this.contactForm.get('familyAccount')?.setValue(false, { emitEvent: false });
      const stored = this.referralDataService.getReferralFormData().contactDetailsData;
      if (stored) {
        stored.familyAccount = false;
      }
      return;
    }
    if (this.familyAccount) {
      this.applyParentAttestation(true, false);
    }
  }

  private isUnder18(dob: any): boolean {
    if (!dob) {
      return false;
    }
    let birthDate: Date;
    if (dob instanceof Date) {
      birthDate = dob;
    } else {
      const parts = String(dob).split('/');
      birthDate =
        parts.length === 3
          ? new Date(+parts[2], +parts[0] - 1, +parts[1])
          : new Date(dob);
    }
    if (isNaN(birthDate.getTime())) {
      return false;
    }
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age < 18;
  }

  get familyAccount(): boolean {
    return !!this.contactForm?.get('familyAccount')?.value;
  }

  onFamilyAccountChange(checked: boolean): void {
    this.contactForm.get('familyAccount')?.setValue(checked, { emitEvent: false });
    this.applyParentAttestation(checked);
    if (checked) {
      const errors = { ...this.validationErrors };
      this.parentAttestationFields.forEach((field) => delete errors[field]);
      this.validationErrors = errors;
    }
  }

  private applyParentAttestation(checked: boolean, emit = true): void {
    this.parentAttestationFields.forEach((field) => {
      const control = this.contactForm.get(field);
      if (!control) {
        return;
      }
      if (checked) {
        control.setValue('', { emitEvent: false });
        control.disable({ emitEvent: false });
      } else if (!this.formReadonly) {
        control.enable({ emitEvent: false });
      }
    });
    if (emit) {
      this.contactForm.updateValueAndValidity();
    }
  }

// hasAnyValue(form: FormGroup): boolean {
//   return Object.values(form.controls).some(control => control.value);
// }

  getFormGroup(controlName: string): FormGroup {
    return this.contactForm.get(controlName) as FormGroup;
  }

  getNzValue(valueName: string): string | undefined {
    const contact = this.communicationType.find((contact: any) => {
      return contact.lkpValueName === valueName;
    });
    return contact ? contact.lkpValueCode : undefined;
  }

  limitDigits(event: any): void {
    let value = event.target.value.replace(/\D/g, '');
    if (value.length > 10) {
      value = value.slice(0, 10);

      event.target.value = value;
      this.contactForm.get('mobile')?.setValue(value);
    }
  }

  limitAltPhoneDigits(event: any): void {
    let value = event.target.value.replace(/\D/g, '');
    if (value.length > 10) {
      value = value.slice(0, 10);

      event.target.value = value;
      this.contactForm.get('altPhone')?.setValue(value);
    }
  }

  ngOnDestroy(): void {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }
}
